import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DepartmentHero,
  DepartmentAbout,
  DepartmentCTA,
  DepartmentServices,
} from '../components/departments';
import Counter from '../components/Counter';
import Testimonials from '../components/Testimonials';

// Icônes
import {
  faCode,
  faMobileAlt,
  faRobot,
  faDatabase,
  faCloud,
  faShieldAlt,
  faUsers,
  faFileAlt,
  faFolder,
  faAward,
} from '@fortawesome/free-solid-svg-icons';

// Images (à importer ou à remplacer par des chemins)
import chefImage from '../images/DGI_Achille_good_450x500.webp';
import logoInformatique from '../images/logo ATC génie informatique_bg.webp';
import webDevImg from '../images/service_site_web_458x500.webp';
import mobileDevImg from '../images/service_app_mobile_458x500.webp';
import iaImg from '../images/service_ia_458x500.webp';
import dbaImg from '../images/service_admin_458x500.webp';
import cloudImg from '../images/service_cloud_458x500.webp';
import cyberImg from '../images/service_cybersecurite_458x500.webp';
import temoin1 from '../images/temoin_info1_80x80.webp';
import temoin2 from '../images/temoin_info2_80x80.webp';
import temoin3 from '../images/temoin_info3_80x80.webp';
import monImage from '../images/genie_informatique_1920x780.webp';
import ctaBackground from '../images/DEVIS_GENIE_INFO_900x500.webp';

const ComputerEngineering = () => {
  const { t } = useTranslation();

  // Données pour le composant Counter (statistiques)
  const statsData = [
    { icon: faUsers, target: 3, label: t('clients_satisfaits'), suffix: '+', color: '#4fc3f7' },
    { icon: faFileAlt, target: 0, label: t('nbre_formations'), suffix: '+', color: '#90ee90' },
    { icon: faFolder, target: 3, label: t('nbre_projets'), suffix: '+', color: '#ffb74d' },
    { icon: faAward, target: 2, label: t('annees_experience'), suffix: '+', color: '#f06292' },
  ];

  // Données pour les témoignages
  const testimonialsData = [
    {
      text: t('msg_temoin1_depart_Info'),
      name: 'Marvin McKinney',
      role: t('role_temoin1_depart_Info'),
      image: temoin1,
    },
    {
      text: t('msg_temoin2_depart_Info'),
      name: 'DEFO Alartson',
      role: t('role_temoin2_depart_Info'),
      image: temoin2,
    },
    {
      text: t('msg_temoin3_depart_Info'),
      name: 'Zonson Adeline',
      role: t('role_temoin3_depart_Info'),
      image: temoin3,
    },
  ];

  // Compétences du département (tags)
  const skills = [
    { label: t('skill1_departement_info'), color: '#107a3e' },
    { label: t('skill2_departement_info'), color: '#107a3e' },
    { label: t('skill3_departement_info'), color: '#107a3e' },
    { label: t('skill4_departement_info'), color: '#107a3e' },
  ];

  return (
    <div className="computer-engineering-page">
      {/* Hero */}
      <DepartmentHero
        title={t('titre_departement_info')}
        subtitle={t('sous_titre_departement_info')}
        breadcrumb={[
          { label: t('titre_departement_info') },
        ]}
        background={monImage}
        badge="Services / Génie Informatique"
        height="large"
      />

      {/* About */}
      <DepartmentAbout
        chefImage={chefImage}
        chefName="M. Achille Tawokam"
        chefRole={t('CHEF_departement_info')}
        chefSocial={[
          { icon: 'facebook', url: 'https://www.facebook.com/achille.kenmogne.9' },
          { icon: 'whatsapp', url: 'https://wa.me/237699388115' },
          { icon: 'linkedin', url: 'https://www.linkedin.com/in/achille-tawokam-1363602ab' },
          { icon: 'tiktok', url: 'https://vm.tiktok.com/ZMHtV6LFAN8Ab-7vvYH/' },
        ]}
        logoImage={logoInformatique}
        title={t('titre_departement_info')}
        subtitle={t('sous_titre_departement_info')}
        description={t('msg_departement_info')}
        skills={skills}
      />

      {/* CTA */}
      <DepartmentCTA
        title={t('titre_devis_departement_info')}
        subtitle={t('sous_titre_devis_departement_info')}
        primaryButton={{ label: t('btn_devis_departement_info'), link: '/contact' }} 
        secondaryButton={{ label: t('btn_FORMATION_devis_departement_info'), link: '/formation' }}
        backgroundImage={ctaBackground} 
        badge="Solutions Digitales"
        formationLink="/formation/informatique" 
      />

      {/* Services */}
      <DepartmentServices
        title={t('titre_service_departement_info')}
        subtitle={t('sous_titre_service_departement_info')}
        services={[
          {
            title: t('dev_web_titre_service_departement_info'),
            icon: faCode,
            color: '#0066cc',
            frontDesc: t('dev_web_msg2_service_departement_info'),
            backDesc: t('dev_web_msg1_service_departement_info'),
            image: webDevImg,
            overlayColor: 'rgba(0, 102, 204, 0.66)',
          },
          {
            title: t('mobile_app_titre_service_departement_info'),
            icon: faMobileAlt,
            color: '#c8a02b',
            frontDesc: t('mobile_app_msg2_service_departement_info'),
            backDesc: t('mobile_app_msg1_service_departement_info'),
            image: mobileDevImg,
            overlayColor: 'rgba(200, 160, 43, 0.66)',
          },
          {
            title: t('ia_titre_service_departement_info'),
            icon: faRobot,
            color: '#107a3e',
            frontDesc: t('ia_msg1_service_departement_info'),
            backDesc: t('ia_msg2_service_departement_info'),
            image: iaImg,
            overlayColor: 'rgba(16, 122, 62, 0.66)',
          },
          {
            title: t('dba_titre_service_departement_info'),
            icon: faDatabase,
            color: '#6b3fa0',
            frontDesc: t('dba_msg2_service_departement_info'),
            backDesc: t('dba_msg1_service_departement_info'),
            image: dbaImg,
            overlayColor: 'rgba(107, 63, 160, 0.66)',
          },
          {
            title: t('cloud_titre_service_departement_info'),
            icon: faCloud,
            color: '#e67e22',
            frontDesc: t('cloud_msg1_service_departement_info'),
            backDesc: t('cloud_msg2_service_departement_info'),
            image: cloudImg,
            overlayColor: 'rgba(230, 126, 34, 0.66)',
          },
          {
            title: t('cybersecurite_titre_service_departement_info'),
            icon: faShieldAlt,
            color: '#107a3e',
            frontDesc: t('cybersecurite_msg1_service_departement_info'),
            backDesc: t('cybersecurite_msg2_service_departement_info'),
            image: cyberImg,
            overlayColor: 'rgba(16, 122, 62, 0.85)',
          },
        ]}
      />

      {/* Statistiques */}
      <Counter stats={statsData} isDark={true} showBar={true} />

      {/* Témoignages */}
      <Testimonials
        title={t('temoignage')}
        subtitle={t('sous_titre_temoignage')}
        testimonials={testimonialsData}
        isDark={false}
      />
    </div>
  );
};

export default ComputerEngineering;